import IsraelMenu from "./IsraelMenu";
import Footer from "../../Components/Footer";
import { Outlet } from "react-router-dom";
import styles from "../../Styles/Trip.module.scss";

function PetraIsraelTrip() {
  return (
    <div>
      <div className={`${styles.menuPosition} ${styles.container}`}>
        <IsraelMenu />
        <div className={styles.content}>
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default PetraIsraelTrip;
